module.exports = __webpack_public_path__ + "static/media/portfolio_pic.018b183d.png";